<template>
 <div id="app">
  <router-view/>
  <notifications position="top right"/>
 </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  },
  data: () => ({

  }),
 
};
</script>
